export default "__VITE_ASSET__JEzyHOC9__"